const infiniti = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "Q50",
          sideView: require("../../../static/images/carcuts/infiniti/side-view/q50-20.png"),
          angleView: require("../../../static/images/carcuts/infiniti/angle-view/q50-2025.png"),
          trims: ["Pure", "Luxe", "Sensory", "Red Sport 400"]
        },
        {
          modelName: "QX55",
          // sideView: require("../../../static/images/carcuts/infiniti/side-view/q60-20.png"),
          angleView: require("../../../static/images/carcuts/infiniti/angle-view/qx55-2025.png"),
          trims: ["Essential", "Luxe"]
        },
      ],
      suvs: [
        {
          modelName: "QX50",
          sideView: require("../../../static/images/carcuts/infiniti/side-view/qx50-20.png"),
          angleView: require("../../../static/images/carcuts/infiniti/angle-view/qx50-2025.png"),
          trims: ["Pure", "Luxe", "Essential", "Sensory", "Autograph"]
        },
        {
          modelName: "QX60",
          sideView: require("../../../static/images/carcuts/infiniti/side-view/qx60-19.png"),
          angleView: require("../../../static/images/carcuts/infiniti/angle-view/qx60-2025.png"),
          trims: ["Pure", "Luxe", "Sensory", "Autograph"]
        },
        {
          modelName: "QX80",
          sideView: require("../../../static/images/carcuts/infiniti/side-view/qx80-20.png"),
          angleView: require("../../../static/images/carcuts/infiniti/angle-view/qx80-2025.png"),
          trims: ["Luxe", "Premium Select", "Sensory"]
        },
      ],
      trucks: [
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/infiniti/lifestyle/qx50-25.png"),
        sedanImage: require("../../../static/images/carcuts/infiniti/lifestyle/qx55-25.png"),
        suvImage: require("../../../static/images/carcuts/infiniti/lifestyle/qx60-25.png"),
        truckImage: require("../../../static/images/carcuts/infiniti/lifestyle/qx80-25.png")
      },
      videoLink: [
        "https://player.vimeo.com/progressive_redirect/playback/1046543436/rendition/1080p/file.mp4?loc=external&signature=cad4536de58397bba7c7f6eaa960befa808447d6fa28a7bb627b0d835003c217"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/infiniti-New.png"), require("../../../static/images/buttons/round-buttons/infiniti-Used.png"), require("../../../static/images/buttons/round-buttons/infiniti-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/infiniti-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/black-new.png"), require("../../../static/images/buttons/browse-buttons/black-used.png"), require("../../../static/images/buttons/browse-buttons/black-service.png"), require("../../../static/images/buttons/browse-buttons/black-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/black01.png"), require("../../../static/images/buttons/swoop-icons/black03.png"), require("../../../static/images/buttons/swoop-icons/black02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/infiniti/CM-AB-24-INFINITI-Established.jpg"), require("../../../static/images/banners/infiniti/CM-AB-24-INFINITI-Lifestyle-v1.jpg"), require("../../../static/images/banners/infiniti/CM-AB-24-INFINITI-Modern.jpg"), require("../../../static/images/banners/infiniti/CM-AB-24-INFINITI-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/infiniti/SOKAL-SRS-112921-DealerDraft-Infinity-1Lifestyle.jpeg"), require("../../../static/images/banners/infiniti/SOKAL-SRS-112921-DealerDraft-Infinity-2Established.jpeg"), require("../../../static/images/banners/infiniti/SOKAL-SRS-112921-DealerDraft-Infinity-3Modern.jpeg"), require("../../../static/images/banners/infiniti/SOKAL-SRS-112921-DealerDraft-Infinity-4Playful.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-infiniti.png"),
        require("../../../static/images/buttons/logos/dd-logo-infiniti-w.png")
      ]
    },
   colors: {
      "--primary-color": "#020B24",
      "--primary-dark": "#000000",
      "--primary-light": "#FFFFFF",
      "--secondary-color": "#B0A591",
      "--secondary-dark": "#646464",
      "--secondary-light": "#E6E6E6",
      "--alt-color": "#DFDBD3"
    },
    fonts: {
      "--heading-text": "Infiniti-Light, Arial, sans-serif",
      "--subheading-text": "Infiniti-Bold, Arial, sans-serif",
      "--body-text": "Infiniti-Light, Arial, sans-serif",
      "--bold-text": "Infiniti-Bold, Arial, sans-serif"
    },
    borderRadius: {
      "--brand-br": "50px"
    }
  })
}


export default infiniti